import type { JSX } from 'preact';
import { useEffect, useRef, useState } from 'preact/hooks';
import { SendIcon } from './icons';

interface ComposerProps {
  busy: boolean;
  onSend: (text: string) => void;
}

export function Composer({ busy, onSend }: ComposerProps): JSX.Element {
  const [value, setValue] = useState('');
  const inputRef = useRef<HTMLTextAreaElement>(null);

  // Focus the input when the panel opens (the Composer mounts with it).
  useEffect(() => {
    inputRef.current?.focus();
  }, []);

  const submit = (): void => {
    const text = value.trim();

    if (text === '' || busy) {
      return;
    }

    onSend(text);
    setValue('');
  };

  const onKeyDown = (event: JSX.TargetedKeyboardEvent<HTMLTextAreaElement>): void => {
    if (event.key === 'Enter' && !event.shiftKey) {
      event.preventDefault();
      submit();
    }
  };

  return (
    <div class="sa-composer">
      <textarea
        ref={inputRef}
        class="sa-input"
        rows={1}
        value={value}
        placeholder="اكتب رسالتك…"
        aria-label="اكتب رسالتك"
        onInput={(event: JSX.TargetedInputEvent<HTMLTextAreaElement>) =>
          setValue(event.currentTarget.value)
        }
        onKeyDown={onKeyDown}
      />
      <button
        type="button"
        class="sa-send"
        onClick={submit}
        disabled={busy || value.trim() === ''}
        aria-label="إرسال"
      >
        <SendIcon />
      </button>
    </div>
  );
}
